export default __webpack_public_path__ + "static/media/330_portfolio02-es-mobile.eca0478b.png";